<template>
<div id="screenContainer">
    <div class="maintenance-content">
        <div class="maintenance-icon">&#9888;</div>
        <div class="maintenance-title">Equipamento em manutenção</div>
        <div class="maintenance-subtitle">Este terminal está temporariamente indisponível</div>
        <br>
        <br>
        <div class="maintenance-subtitle">ID do terminal: {{ clientId }}</div>
        <br>
        <br>
        <div class="maintenance-subtitle">{{ message }}</div>
        <div class="maintenance-progress" v-if="progress > 0">
            <div class="maintenance-progress-bar">
                <div class="maintenance-progress-fill" :style="{ width: progress + '%' }"></div>
            </div>
            <div class="maintenance-progress-label">{{ progress }}%</div>
            <div class="maintenance-progress-label">{{ progressMessage }}</div>
        </div>
    </div>
    <div class="keypass" v-if="!configButton">
        <div class="k1" @click="keypass('k1')"></div>
        <div class="k2" @click="keypass('k2')"></div>
        <div class="k3" @click="keypass('k3')"></div>
    </div>
    <div class="config-button" @click="enterLogin()" v-else></div>
</div>
</template>

<script>
import Util from '@/assets/libs/util'
import eventModule from '@/assets/libs/eventModule'
import requestModule from '@/assets/libs/requestModule'
import WebsocketController from '@/assets/controllers/WebsocketController'

export default {
    name: 'MaintenancePage',
    data () {
        return {
            message: WebsocketController.getMessage() || 'Servidor desconectado',
            progress: 0,
            configButton: false,
            clientId: '',
            keys: {
                k1: this.k1,
                k2: this.k2,
                k3: this.k3
            },
            keysPressed: [],
            progressMessage: ''
        }
    },
    created () {
        eventModule.$on('setMessage', this.onSetMessage)
        eventModule.$on('setProgress', this.onSetProgress)
        eventModule.$on('updateBaseConfig', this.onUpdateBaseConfig)
    },
    beforeDestroy () {
        eventModule.$off('setMessage', this.onSetMessage)
        eventModule.$off('setProgress', this.onSetProgress)
        eventModule.$off('updateBaseConfig', this.onUpdateBaseConfig)
    },
    mounted () {
        this.onUpdateBaseConfig()
    },
    methods: {
        onSetMessage: function (msg) {
            this.message = msg
        },
        onSetProgress: function (value, progressMessage) {
            this.progress = value
            this.progressMessage = progressMessage || ''
        },
        onUpdateBaseConfig: async function () {
            let self = this
            if (!Util.isOracle()) {
                requestModule.postRequest('getBaseConfig', { type: 'basic' }).then(confData => {
                    self.configButton = typeof (confData.configButton) === 'boolean' ? confData.configButton : false
                })
            }
            this.clientId = Util.getLocalVar('clientId') || 'Não informado'
        },
        k1: function () {
            this.keysPressed = []
            this.keysPressed.push(2)
        },
        k2: function () {
            this.keysPressed.push(1)
            if (this.keysPressed.length === 4) {
                let sum = this.keysPressed.reduce((partialSum, a) => partialSum + a, 0)
                if (sum === 3) {
                    this.enterLogin()
                }
            }
        },
        k3: function () {
            this.keysPressed.push(-1)
        },
        keypass: function (k) {
            this.keys[k]()
        },
        enterLogin: function () {
            this.$router.push({
                name: 'Login',
                params: { 'allowed': true }
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    #screenContainer {
        width: 100vw;
        height: 100vh;
        background-color: #ffba5f;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .keypass {
            position: absolute;
            display: block;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            pointer-events: none;

            div {
                display: block;
                width: 320px;
                height: 320px;
                margin-bottom: 15px;
                z-index: 100;
                position: absolute;
                pointer-events: auto;

                &.k1 {
                    background: none;
                    bottom: 0;
                    left: 0;
                }

                &.k2 {
                    top: 0;
                    background: none;
                }

                &.k3 {
                    background: none;
                    top: 0;
                    right: 0;
                }
            }
        }

        .config-button {
            position: absolute;
            top: 0;
            right: 0;
            opacity: 0;
            height: 200px;
            width: 200px;
            z-index: 100;
        }

        .maintenance-content {
            text-align: center;
            text-transform: uppercase;
            padding: 50px 30px;

            .maintenance-icon {
                font-size: 12em;
                line-height: 1;
                margin-bottom: 60px;
            }

            .maintenance-title {
                font-size: 3em;
                font-weight: 600;
                margin-bottom: 30px;
            }

            .maintenance-subtitle {
                font-size: 2.2em;
                font-weight: 400;
            }

            .maintenance-progress {
                margin-top: 40px;
                width: 100%;
                max-width: 600px;
                margin-left: auto;
                margin-right: auto;

                .maintenance-progress-bar {
                    width: 100%;
                    height: 24px;
                    background-color: rgba(0, 0, 0, 0.15);
                    border-radius: 12px;
                    overflow: hidden;

                    .maintenance-progress-fill {
                        height: 100%;
                        background-color: #333;
                        border-radius: 12px;
                        transition: width 0.3s ease;
                    }
                }

                .maintenance-progress-label {
                    margin-top: 12px;
                    font-size: 1.6em;
                    font-weight: 500;
                }
            }
        }
    }

    @media (max-width: 698px) { // Gertec SK210
        #screenContainer {
            .keypass {
                div {
                    width: 80px;
                    height: 80px;
                    margin-bottom: 0;

                    &.k1 {
                        bottom: 30px;
                    }
                }
            }

            .maintenance-content {
                padding: 20px 15px;

                .maintenance-icon {
                    font-size: 5em;
                    margin-bottom: 20px;
                }

                .maintenance-title {
                    font-size: 1.2em;
                    margin-bottom: 10px;
                }

                .maintenance-subtitle {
                    font-size: 0.9em;
                }

                .maintenance-progress {
                    margin-top: 15px;
                    max-width: 280px;

                    .maintenance-progress-bar {
                        height: 14px;
                    }

                    .maintenance-progress-label {
                        margin-top: 6px;
                        font-size: 0.8em;
                    }
                }
            }
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        #screenContainer {
            .maintenance-content {
                padding: 40px 30px;

                .maintenance-icon {
                    font-size: 9em;
                    margin-bottom: 40px;
                }

                .maintenance-title {
                    font-size: 2.5em;
                    margin-bottom: 20px;
                }

                .maintenance-subtitle {
                    font-size: 1.8em;
                }
            }
        }
    }

    @media (orientation: landscape) {
        #screenContainer {
            .keypass {
                div {
                    display: block;
                    width: 220px;
                    height: 220px;
                    margin-bottom: 0;
                    z-index: 100;
                }
            }

            .maintenance-content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 100vh;
                box-sizing: border-box;
                padding: 20px 40px;

                .maintenance-icon {
                    font-size: 7em;
                    margin-bottom: 30px;
                }

                .maintenance-title {
                    font-size: 2em;
                    margin-bottom: 15px;
                }

                .maintenance-subtitle {
                    font-size: 1.4em;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/MaintenancePage.vue